<template>
  <b-card no-body class="serv-es margen-inferior-sub">
    <b-card-header
      class="row"
      @click="visible = !visible"
      :class="visible ? null : 'collapsed'"
      :aria-expanded="visible ? 'true' : 'false'"
      :aria-controls="identificadorColapsable"
    >
      <h5 class="col mb-0">
        <button class="btn btn-link collapsed" type="button">{{tituloColapsable}}</button>
      </h5>
      <span class="col-1 ml-auto text-md-right px-0 d-none d-md-inline-block when-close">
        <FontAwesomeIcon icon="plus" class="h3" />
      </span>
      <span class="col-1 ml-auto text-md-right px-0 d-none d-md-inline-block when-open">
        <FontAwesomeIcon icon="minus" class="h3" />
      </span>
    </b-card-header>
    <b-collapse :id="identificadorColapsable" v-model="visible" :accordion="identificadorAcordion">
      <b-card-body :class="classCardBody">
        <slot />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faPlus, faMinus);
export default {
  name: "SubColapsable",
  props: {
    tituloColapsable: { type: String },
    identificadorColapsable: { type: String },
    identificadorAcordion: { type: String },
    classCardBody: { type: String, default: "px-4" }
  },
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      visible: false
    };
  }
};
</script>

<style>
.margen-inferior-sub {
  margin-bottom: 1rem !important;
}
</style>


// WEBPACK FOOTER //
// src/components/generales/paginas/SubColapsable.vue